import AlbumPage from "@pages/Album/AlbumPage";
import ArtistPage from "@pages/Artist/ArtistPage";
import CuriositiesPage from "@pages/Curiosities";
import Help from "@pages/Help";
import PaymentPage from "@pages/Signup/PaymentPage";
import SettingsPage from "@pages/Signup/SettingsPage";
import TosPage from "@pages/Signup/TosPage";
import React from "react";
import { useRoutes } from "react-router-dom";
import { useTokenContext } from "./auth/UserTokenProvider";
import MetaTags from "./components/MetaTags";
import LyricsView from "./pages/LyricsView";
import NotFound from "./pages/NotFound";
import SpotifyAuthorization from "./pages/SpotifyAuthorization";

interface AppRoutesProps {
  currentlyPlayingSong: any; // Replace 'any' with the actual type if available
  user: any; // Replace 'any' with the actual type if available
  userLoading: boolean;
  lyrics: any; // Replace 'any' with the actual type if available
  onThemeToggle: () => void;
  isDarkMode: boolean;
}

const AppRoutes: React.FC<AppRoutesProps> = ({
  currentlyPlayingSong,
  user,
  userLoading,
  lyrics,
  onThemeToggle,
  isDarkMode
}) => {
  const { onNewToken } = useTokenContext();

  const routes = [
    {
      path: "/",
      element: (
        <MetaTags
          route="/"
          titlePrefix="Home - "
          description="Spotify Panel is a tool that allows you to view the lyrics of the current playing song on Spotify."
        >
          <LyricsView
            currentlyPlayingSong={currentlyPlayingSong}
            user={user}
            userLoading={userLoading}
            lyrics={lyrics}
          />
        </MetaTags>
      )
    },
    {
      path: "/help",
      element: (
        <MetaTags route="/help" titlePrefix="Help - " description="Get help with Spotify Panel.">
          <Help />
        </MetaTags>
      )
    },
    {
      path: "/settings",
      element: (
        <MetaTags route="/settings" titlePrefix="Settings - " description="View your preferences.">
          <SettingsPage onThemeToggle={onThemeToggle} isDarkMode={isDarkMode} />
        </MetaTags>
      )
    },
    {
      path: "/album",
      element: (
        <MetaTags route="/album" titlePrefix="Album - " description="View Current Album.">
          <AlbumPage />
        </MetaTags>
      )
    },
    {
      path: "/album/:albumId",
      element: (
        <MetaTags route="/album" titlePrefix="Album - " description="View Album.">
          <AlbumPage />
        </MetaTags>
      )
    },
    {
      path: "/artist/:artistId",
      element: (
        <MetaTags route="/artist" titlePrefix="Artist - " description="View Artist Songs.">
          <ArtistPage currentlyPlayingSong={currentlyPlayingSong} />
        </MetaTags>
      )
    },
    {
      path: "/curiosities",
      element: (
        <MetaTags
          route="/curiosities"
          titlePrefix="Curiosities - "
          description="View song curiosities and challenging expressions."
        >
          <CuriositiesPage currentlyPlayingSong={currentlyPlayingSong} />
        </MetaTags>
      )
    },
    {
      path: "/tos",
      element: (
        <MetaTags route="/tos" titlePrefix="Terms of Service " description="View Terms of Service">
          <TosPage />
        </MetaTags>
      )
    },
    {
      path: "/payment",
      element: (
        <MetaTags route="/payment" titlePrefix="Payment - " description="Initiate payment">
          <PaymentPage />
        </MetaTags>
      )
    },
    {
      path: "/reactivate",
      element: (
        <MetaTags route="/payment" titlePrefix="Payment - " description="Initiate payment">
          <PaymentPage />
        </MetaTags>
      )
    },
    {
      path: "/spotify-authorization",
      element: <SpotifyAuthorization onNewToken={onNewToken} />
    },
    {
      path: "/spotify-authorization/",
      element: <SpotifyAuthorization onNewToken={onNewToken} />
    },
    {
      path: "*",
      element: <NotFound />
    }
  ];

  return useRoutes(routes);
};

export default AppRoutes;
